$(function(){
  // add type
  $("html").attr("data-type", "kankou");

  // purl
  //------------------------------------------------------------
  var purl = $.url().param("purl");
  $("html").addClass(purl);

  var bodyclass = $.url().param("bodyclass");
  $("body").addClass(bodyclass);

  var bodyid = $.url().param("bodyid");
  $("body").attr("id", bodyid);

  // tile
  //------------------------------------------------------------
  $(window).on('load resize', function(){

    // PC用
    if( window.matchMedia('(min-width:787px)').matches ){
      // $(".cmn-posts-pamphlet .post a").removeAttr("height");
      // $(".cmn-posts-pamphlet .post a").tile(3);

      $(".spot-search .check-list .parent").each(function(){
        $("li label", this).tile(2);
      });

      $(".spot-search .check-list2 .parent").each(function(){
        $("li label", this).tile(2);
      });

      $(".cmn-posts-1 .post .texts dl").tile(4);
    }

    // SP用
    if( window.matchMedia('(max-width:787px)').matches ){
      // $(".cmn-posts-pamphlet .post a").removeAttr("height");
      // $(".cmn-posts-pamphlet .post a").tile(2);
      // $("#spot.detail .box-pamphlet .post .text").tile(2);

      $(".spot-search .check-list .parent label").tile(2);

      $(".spot-search .check-list2 .parent").each(function(){
        $("li label", this).tile(2);
      });
    }
  });

  // masonry
  $(window).on('load', function(){
    $(".cmn-posts-pamphlet .posts").masonry();
  });

  // auto blanker
  //------------------------------------------------------------
  $("a[href*='.pdf']").each(function(){
    $(this).addClass("pdflink");
    $(this).attr("target", "_blank");
    // $(this).parents().filter("li").addClass("li-pdf");
  });

  // placeholder
  //------------------------------------------------------------
  if( $("html").is(".msie9, .msie8") ){
    $('#side [placeholder]').ahPlaceholder({
      placeholderColor : '#bbbbbb',
      placeholderAttr  : 'placeholder',
      likeApple        : false
    });

    $(".input-set").each(function(){
      var that = this;
      if( $(".type-list", that).length === 0 ){
        $('[placeholder]', that).ahPlaceholder({
          placeholderColor : '#bbbbbb',
          placeholderAttr  : 'placeholder',
          likeApple        : false
        });
      }
    });

    $("#site-search #cont [placeholder], .cmn-form-1 [placeholder]").ahPlaceholder({
      placeholderColor : '#bbbbbb',
      placeholderAttr  : 'placeholder',
      likeApple        : false
    });
  }

  // spot list 条件を変えて再検索 placeholder
  //------------------------------------------------------------
  $(".spot-search .input-set label").on('tap', function(){
    var text = $(this).text();
    var li = $(this).parents().filter("li");
    var obj = $("input", li);
    obj.prop("checked", !obj.prop("checked")); // toggleCheck
    $(".spot-search .input-set [placeholder]").attr("placeholder", text);
  });

  // season
  //------------------------------------------------------------
  const ssARR = [
    ["1", "winter"],["2", "winter"],["3", "spring"],
    ["4", "spring"],["5", "spring"],["6", "summer"],
    ["7", "summer"],["8", "summer"],["9", "autumn"],
    ["10", "autumn"],["11", "autumn"],["12", "winter"]
  ];

  var date = new Date();
  var month = date.getMonth();
  var season = ssARR[month][1];
  var m = ssARR[month][0];
  $("html").attr("data-season", season);
  $("html").attr("data-month", m);
});



// WEBPACK FOOTER //
// ./_src/js/init/ready.js